import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CoffeeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"coffee"}/>
}
